<div class="container m-b-20 layout-row align-end">
  <button mat-raised-button color="primary" (click)="editSchedule()">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit Schedule' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <form [formGroup]="groupEditMeetingForm">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Repetition Frequency' | translate }}</mat-label>
            <mat-select formControlName="frequency">
              @for (option of frequencyOptions; track option) {
                <mat-option [value]="option.id">
                  {{ option.value }}
                </mat-option>
              }
            </mat-select>
            @if (groupEditMeetingForm.controls.frequency.hasError('repeatsOnDay')) {
              <mat-error>
                {{ 'labels.inputs.Repetition Frequency' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Repetition Interval' | translate }}</mat-label>
            <mat-select formControlName="interval">
              @for (interval of repetitionIntervals; track interval) {
                <mat-option [value]="interval">
                  {{ interval }}
                </mat-option>
              }
            </mat-select>
            @if (groupEditMeetingForm.controls.interval.hasError('repeatsOnDay')) {
              <mat-error>
                {{ 'labels.inputs.Repeition Interval' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          @if (groupEditMeetingForm.contains('repeatsOnDay')) {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Repeats on Day' | translate }}</mat-label>
              <mat-select formControlName="repeatsOnDay" required>
                @for (day of repeatsOnDays; track day) {
                  <mat-option [value]="day.id">
                    {{ day.value }}
                  </mat-option>
                }
              </mat-select>
              @if (groupEditMeetingForm.controls.repeatsOnDay.hasError('repeatsOnDay')) {
                <mat-error>
                  {{ 'labels.inputs.At least' | translate }} <strong>{{ 'labels.inputs.one' | translate }}</strong>
                  {{ 'labels.inputs.day must be selected' | translate }}
                </mat-error>
              }
            </mat-form-field>
          }

          <mat-form-field class="m-b-5" (click)="startDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Above Changes are Effective from' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="startDatePicker"
              required
              formControlName="startDate"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            @if (groupEditMeetingForm.controls.startDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Changes Affection Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
            <mat-hint>
              {{ "labels.text.Repeats' and 'Repeats every" | translate }}
            </mat-hint>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!groupEditMeetingForm.valid"
          (click)="submit()"
          *LOSxHasPermission="'CREATE_MEETING'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
